<template>
  <div class="barcode-canvas">
    <canvas v-if="value" ref="canvas"></canvas>
    <div v-else class="barcode-canvas__empty">
      {{ $t('barcodeCanvas.noValue') }}
    </div>
  </div>
</template>

<script>
// JsBarcode draws directly onto the canvas element we pass it, there's no
// Vue-friendly return value to bind in the template instead.
import JsBarcode from 'jsbarcode'

// Maps our stored `barcode_format` choice to JsBarcode's symbology name.
const JSBARCODE_FORMAT_MAP = {
  code128: 'CODE128',
  ean13: 'EAN13',
  upca: 'UPC',
}

export default {
  name: 'BarcodeCanvas',
  props: {
    value: {
      type: String,
      default: null,
    },
    format: {
      type: String,
      default: 'code128',
    },
    height: {
      type: Number,
      default: 40,
    },
  },
  watch: {
    value() {
      this.render()
    },
    format() {
      this.render()
    },
  },
  mounted() {
    this.render()
  },
  updated() {
    this.render()
  },
  methods: {
    render() {
      if (!this.value || !this.$refs.canvas) {
        return
      }
      try {
        JsBarcode(this.$refs.canvas, this.value, {
          format: JSBARCODE_FORMAT_MAP[this.format] || 'CODE128',
          height: this.height,
          displayValue: false,
          margin: 4,
        })
      } catch (error) {
        // A source value that isn't valid for the chosen symbology (e.g.
        // non-numeric text fed into EAN-13/UPC-A) must not crash the cell --
        // JsBarcode throws synchronously on invalid input.
        this.clearCanvas()
      }
    },
    clearCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas) {
        return
      }
      const context = canvas.getContext('2d')
      context?.clearRect(0, 0, canvas.width, canvas.height)
    },
  },
}
</script>
